<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon
                                   @click="$router.push({name: 'campaign', params: {campaignId: $route.params.campaignId}})"
                                   v-on="on"
                            >
                                <v-icon x-large>mdi-chevron-left</v-icon>
                            </v-btn>
                        </template>
                        <span>Go Back</span>
                    </v-tooltip>
                    Unlock Item Design
                </h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6" lg="4" xl="3" v-for="(item, itemIndex) of items" :key="itemIndex">

                <v-card>
                    <v-card-title>#{{ item.number }} - {{ item.title }}</v-card-title>
                    <v-card-text>
                        <div>{{ item.description }}</div>
                        <div>Cost: {{ item.cost }}</div>
                        <div>Slot: {{ item.slot }}</div>
                        <div>Upon Usage: {{ item.discard_effect }}</div>
                        <div>Number of Items: {{ item.amount }}</div>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="unlockDesign(item)"
                                       v-on="on"
                                >
                                    <v-icon>mdi-lock-open</v-icon>
                                </v-btn>
                            </template>
                            <span>Unlock Item Design</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import ItemService from "../services/ItemService";
  import CampaignService from "../services/CampaignService";

  export default {
    data: () => ({
      items: []
    }),

    created() {
      this.indexItems();
    },

    methods: {
      indexItems() {
        ItemService.indexByCampaign(this.$route.params.campaignId)
          .then(response => {
            this.items = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      unlockDesign(item) {
        if (confirm(`Are you sure you want to unlock the design #${item.number}?`)) {
          CampaignService.unlockItemsByNumber(this.$route.params.campaignId, item.id)
            .then(() => {
              this.$router.push({name: 'campaign', params: {campaignId: this.$route.params.campaignId}})
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  };
</script>
